import React, { Component } from "react";

import Checkbox from "@material-ui/core/Checkbox";

import { Link } from "react-router-dom";

import classnames from "classnames";

import { animateScroll } from "react-scroll";

import { pushDatatoServer } from "../../../../components/utils/RequestsHelper";

import PropTypes from "prop-types";

import { transformIdentifier } from '../../../../utils/Utils';

const myStyle = {
  padding: "0",
};

class FormContacto extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      phoneNumber: "",
      identifier: "",
      email: "",
      frontPage: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateData = this.validateData.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mode === "Editar" && nextProps.data.name !== undefined) {
      let data = nextProps.data;

      this.setState({
        name: data.name,
        phoneNumber: data.phoneNumber,
        email: data.email,
        frontPage: data.frontPage,
        identifier: data.identifier,
      });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCheckBoxChange() {
    this.setState({ frontPage: !this.state.frontPage });
  }

  handleFieldsChanges = (value, field) => {
    this.setState({ [field]: value });
  };

  renderMandatoryMessage = (field) => {
    if (this.state[field] === true) {
      return <span className="alert-danger ml-6">Campo obrigatório</span>;
    }
  };

  renderIdentifierExists = () => {
    if (this.state.identifierExists === true) {
      return <span className="alert-danger ml-6">Identificador já existe</span>;
    }
  };

  render() {

    return (
      <div className="row">
        <div className="col-12">
          <p className="labels">
            Nome*{this.renderMandatoryMessage("nameMissing")}
          </p>
          <input
            className={classnames(
              "input-form",
              this.state.isNameValid === false ? "bad-form" : ""
            )}
            type="text"
            name="name"
            value={this.state.name}
            placeholder="Nome Contacto"
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12 col-sm-6">
          <p className="labels">
            Número de Telefone*{this.renderMandatoryMessage("phoneNumberMissing")}
          </p>
          <input
            className={classnames(
              "input-form",
              this.state.isPhoneNumberValid === false ? "bad-form" : ""
            )}
            type="text"
            name="phoneNumber"
            placeholder="Número de Telefone"
            value={this.state.phoneNumber}
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12 col-sm-6">
          <p className="labels">Email</p>
          <input
            className={classnames(
              "input-form",
              this.state.isEmailValid === false ? "bad-form" : ""
            )}
            type="text"
            name="email"
            placeholder="Email do contacto"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </div>

        <div className="col-6 col-sm-3">
          
            <div>
              <p className="labels">Aparece na Página Inicial?</p>
              <Checkbox
                checked={this.state.frontPage}
                onChange={this.handleCheckBoxChange}
                value={this.state.isActive}
                name="isActive"
                inputProps={{
                  "aria-label": "primary checkbox",
                }}
              />
            </div>
          
        </div>

        <div className="col-12 submit-buttons">
          <button
            onClick={this.handleSubmit}
            className="backoffice-btn btn btn-outline-success"
          >
            {this.props.mode === "create" ? "Adicionar" : "Editar"}
          </button>

          <Link
            className="backoffice-btn btn btn-outline-danger"
            to={"/backoffice/pontos_interesse"}
          >
            Cancelar
          </Link>
        </div>
      </div>
    );
  }

  handleSubmit() {
    console.log(this.state);
    let isFormValid = this.validateData();

    if (isFormValid) {
      let data = {
        name: this.state.name,
        phoneNumber: this.state.phoneNumber,
        email: this.state.email,
        identifier: this.props.mode === "create" ? transformIdentifier(this.state.name) : this.state.identifier,
        frontPage: this.state.frontPage,
      };

      this.saveContacto(data);
    } else {
      animateScroll.scrollToTop({ smooth: true, spy: true, duration: 1000 });
    }
  }

  saveContacto = async (data) => {
    let res = {};
    try {
      if (this.props.mode === "create") {
        res = await pushDatatoServer("/api/contactos", data, "post");
      } else {
        res = await pushDatatoServer(
          "/api/contactos/" + data.identifier,
          data,
          "put"
        );
      }

      if (
        res.response.data.errors !== undefined &&
        res.response.data.errors.length !== 0
      ) {
        const missingFields = res.response.data["errors"];

        for (let x = 0; x < missingFields.length; x++) {
          if (missingFields[x].param === "identifier") {
            this.setState({ identifierExists: true });
            this.setState({ isIdentifierValid: false });
            animateScroll.scrollToTop({
              smooth: true,
              spy: true,
              duration: 1000,
            });
          }
        }
      } else {
        this.context.router.history.push("/backoffice/contactos");
      }
    } catch (err) {
      this.context.router.history.push("/backoffice/contactos");
    }
  };

  validateData = () => {
    let isFormValid = true;

    if (!this.validateField("name", "isNameValid")) {
      isFormValid = false;
    }

    if (!this.validateField("phoneNumber", "isPhoneNumberValid")) {
      isFormValid = false;
    }

    return isFormValid;
  };

  validateField = (field, isValidValue) => {
    let newState = {};
    let isValid = true;
    let missingString = field + "Missing";

    if (
      this.state[field] === "" ||
      this.state[field] === undefined ||
      this.state[field].length === 0
    ) {
      this.setState({ [missingString]: true });
      isValid = false;
    } else {
      this.setState({ [missingString]: "" });
    }

    newState[isValidValue] = isValid;
    this.setState(newState);
    return isValid;
  };
}

export default FormContacto;
